"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEED_ACTION_TYPES_HIDDEN_FROM_NETWORK = exports.NEED_ACTION_FILTER_ORIGINS = exports.NEED_ACTION_MANUAL_TYPES = exports.NEED_ACTION_SYSTEM_ACTOR = exports.NEED_ACTION_SYSTEM_TYPES = exports.NEED_ACTION_SPONSO_TYPES = exports.toSponsoAction = exports.SPONSO_CAMPAIGNS = exports.SPONSO_CAMPAIGN_ACTIONS = exports.NEED_ACTION_CRM_CHANNELS = exports.NEED_ACTION_TYPES = exports.NEED_ACTION_SOURCES = void 0;
exports.isNeedActionSponsoType = isNeedActionSponsoType;
exports.isSponsoCampaign = isSponsoCampaign;
exports.isNeedActionSystemType = isNeedActionSystemType;
exports.isAutomaticNeedActionType = isAutomaticNeedActionType;
const lib_custom_types_1 = require("@backend/lib-custom-types");
exports.NEED_ACTION_SOURCES = (0, lib_custom_types_1.strictUnionArray)()([
    'AUTOMATIC',
    'MANUAL',
    'ACTION_TRACKER_SPREADSHEET_IMPORT',
]);
exports.NEED_ACTION_TYPES = (0, lib_custom_types_1.strictUnionArray)()([
    'CRM',
    'SOURCING_HELLOWORK',
    'SOURCING_FRANCE_TRAVAIL',
    'SOURCING_METEOJOB',
    'SOURCING_INDEED',
    'SOURCING_APEC',
    'SOURCING_LINKEDIN',
    'SOURCING_ISP',
    'POSTING_POLE_EMPLOI',
    'POSTING_APEC',
    'REFRESH_ANNONCE',
    'MODIFICATION_ANNONCE',
    'DUPLICATION_ANNONCE',
    'ANNONCE_PE_JTMO_DESACTIVEE',
    'INDEED_SPONSO',
    'INDEED_SPONSO_PLUS',
    'INDEED_SPONSO_REMOVAL',
    'PS_DIAGNOSTIC_TS',
    'DIAGNOSTIC_FICHE_DE_POSTE',
    'PUBLICATION_GROUPE_FACEBOOK',
    'RELANCE_TRAITEMENT_CV',
    'AMELIORATION_OFFRE_GPT',
    'PARTENARIAT_PE_ML_FORMATION',
    'CAMPAGNE_ONLINE_SPECIFIQUE',
    'PRIME_COOPTATION_BOOSTEE',
]);
exports.NEED_ACTION_CRM_CHANNELS = (0, lib_custom_types_1.strictUnionArray)()(['DIRECT_MESSAGE', 'INVITE_TO_APPLY']);
exports.SPONSO_CAMPAIGN_ACTIONS = {
    BOOST: 'INDEED_SPONSO',
    'P2.0': 'INDEED_SPONSO_PLUS',
    'P2.1': 'INDEED_SPONSO_PLUS',
};
function isNeedActionSponsoType(type) {
    return exports.NEED_ACTION_SPONSO_TYPES.some(sponsoType => sponsoType === type);
}
exports.SPONSO_CAMPAIGNS = Object.keys(exports.SPONSO_CAMPAIGN_ACTIONS);
function isSponsoCampaign(campaign) {
    return campaign !== undefined && exports.SPONSO_CAMPAIGNS.some(sponsoCampaign => sponsoCampaign === campaign);
}
const toSponsoAction = (campaign) => isSponsoCampaign(campaign) ? exports.SPONSO_CAMPAIGN_ACTIONS[campaign] : undefined;
exports.toSponsoAction = toSponsoAction;
exports.NEED_ACTION_SPONSO_TYPES = (0, lib_custom_types_1.strictUnionArray)()([
    'INDEED_SPONSO',
    'INDEED_SPONSO_PLUS',
    'INDEED_SPONSO_REMOVAL',
]);
exports.NEED_ACTION_SYSTEM_TYPES = (0, lib_custom_types_1.strictUnionArray)()([
    'REFRESH_ANNONCE',
    'MODIFICATION_ANNONCE',
    'POSTING_POLE_EMPLOI',
    'ANNONCE_PE_JTMO_DESACTIVEE',
    ...exports.NEED_ACTION_SPONSO_TYPES,
]);
function isNeedActionSystemType(type) {
    return exports.NEED_ACTION_SYSTEM_TYPES.some(systemType => systemType === type);
}
exports.NEED_ACTION_SYSTEM_ACTOR = 'SYSTEM';
function isAutomaticNeedActionType(type) {
    return type === 'CRM' || isNeedActionSystemType(type);
}
exports.NEED_ACTION_MANUAL_TYPES = exports.NEED_ACTION_TYPES.filter(type => !isAutomaticNeedActionType(type));
exports.NEED_ACTION_FILTER_ORIGINS = (0, lib_custom_types_1.strictUnionArray)()([
    'CHOSEN',
    'INHERITED',
    'REMOVED',
]);
exports.NEED_ACTION_TYPES_HIDDEN_FROM_NETWORK = ['INDEED_SPONSO_REMOVAL'];
